import { render } from "./BilTunggak.vue?vue&type=template&id=381bea4f"
import script from "./BilTunggak.vue?vue&type=script&lang=js"
export * from "./BilTunggak.vue?vue&type=script&lang=js"

import "./BilTunggak.vue?vue&type=style&index=0&id=381bea4f&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__